<template>
    <div>
        <div v-show="isDataTableLoading === false">
            <template  v-if="bill_payments === true">
                <div class="page-top mb-1 mb-3 align-left clearfix">
                    <h1> Bill Payments</h1>
                </div>
                <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'bill_payment'" :billIds="billIds"></virtualAccountComponent>
                <fincaComponent v-else-if="paymentEngine == 'FINCA' " :paymentType="'bill_payment'" :billIds="billIds"></fincaComponent>
                <meezanComponent v-else-if="paymentEngine == 'MEEZAN' " :paymentType="'bill_payment'" :billIds="billIds" :meezan_balance="meezan_balance"></meezanComponent>
                <!-- In future payment engine here -->

                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="new-tab"  data-toggle="tab" href="#new" role="tab" aria-controls="new" aria-selected="true" @click="reloadList('new')" >New ({{new_bills_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab" aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')" >In Process ({{inprocess_bills_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="rejected-tab"  data-toggle="tab" href="#rejected" role="tab" aria-controls="rejected" aria-selected="false" @click="reloadList('rejected')" >Rejected ({{rejected_bills_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="paid-tab" data-toggle="tab" href="#paid" role="tab" aria-controls="paid" aria-selected="false" @click="reloadList('paid')" >Paid ({{paid_bills_count}})</a>
                        </li>
                    </ul>
                    <button v-if="process_bill == true" class="btn btn-primary float-right" id="processBill" data-toggle="modal" data-target="#loginMoblizer" disabled> Process </button>
                    <router-link v-if="add_bill == true" to="/addBillPayment" class="btn btn-primary float-right mr-1"> Add Bill</router-link>
                    <router-link v-if="add_bill == true" to="/bulkBillPayments" class="btn btn-primary float-right mr-1"> Bulk Bill Payments</router-link>
                </div>

                <div v-if="this.$global.user_vr_corp == 'YES' && this.display_process_bill == true && this.bill_selected_to_pay > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                    <p class="pl-2 pr-2"><b> Warning! </b> Your account has insufficient balance for the bill(s) to process. Current Balance : {{this.$global.user_vr_balance}}</p>
                </div>
                <div v-if="this.$global.user_vr_corp == 'NO' && this.display_process_bill == true && this.bill_selected_to_pay > this.corporateAccountBalance" class="alert alert-danger" role="alert">
                    <p class="pl-2 pr-2"><b> Warning! </b> Your account has insufficient balance for the bill(s) to process. Current Balance : {{this.corporateAccountBalance}}</p>
                </div>
                <div class="tab-content" id="myTabContent">

                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="dt-new" class="table" style="width:100%">
                            <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Title</th>
                                <th>Comment</th>
                                <th>Category</th>
                                <th>Company</th>
                                <th>Reference no</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th class="text-center">Action</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="inprocess"  role="tabpanel" aria-labelledby="inprocess-tab">
                        <div class="table-holder">
                            <table id="dt-inprocess" class="table table-responsive-xl" style="width:100%">
                                <thead>
                                <tr>
                                    <th style="display: none;"></th>
                                    <th>Title</th>
                                    <th>Comment</th>
                                    <th>Category</th>
                                    <th>Company</th>
                                    <th>Reference no</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="rejected"  role="tabpanel" aria-labelledby="rejected-tab">
                        <div class="table-holder">
                            <table id="dt-rejected" class="table table-responsive-xl" style="width:100%">
                                <thead>
                                <tr>
                                    <th style="display: none;"></th>
                                    <th>Title</th>
                                    <th>Comment</th>
                                    <th>Category</th>
                                    <th>Company</th>
                                    <th>Reference no</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="paid" role="tabpanel" aria-labelledby="paid-tab">
                        <div class="table-holder">
                            <table id="dt-paid" class="table table-responsive-xl" style="width:100%">
                                <thead>
                                <tr>
                                    <th style="display: none;"></th>
                                    <th>Title</th>
                                    <th>Comment</th>
                                    <th>Category</th>
                                    <th>Company</th>
                                    <th>Reference no</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">
                                        Action
                                    </th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>

            </template>
            <template v-else-if="bill_payments === null"><preLoader></preLoader></template>
            <template v-else-if="bill_payments === false"><notAllowed></notAllowed></template>
        </div>
        <preLoader v-show="isDataTableLoading === true"></preLoader>
    </div>
</template>

<script>
    var gThat = null;
    import virtualAccountComponent from '../modals/virtualAccountComponent';
    import fincaComponent from '../modals/fincaComponent';
    import meezanComponent from '../modals/meezanComponent';

    export default {
        components: {
            virtualAccountComponent,
            meezanComponent,
            fincaComponent
        },
        data() {
            return {
                data : null,
                billIds: [],
                paymentEngine: '',
                bill_payments: null,
                process_bill: null,
                add_bill: null,
                new_bills_count : '',
                inprocess_bills_count : '',
                rejected_bills_count : '',
                paid_bills_count: '',
				currentActiveTab : 'new',
                isDataTableLoading: false,
                dtNewBPayments: null,
                dtInProcessBPayments: null,
                dtRejectedBPayments: null,
                dtPaidBPayments: null,
                delete_bill_payment: false,
                delete_bill_payment_permission: false,
                form: new Form({
                    id : '',
                }),
                bill_data : [],
                bill_selected_to_pay : 0,
                display_process_bill : false,
                corporateAccountBalance : null,
                meezan_balance : '',
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.getCorporateCompanyBalance();
            this.can('process_bill|add_bill|bill_payments').then(result => {
                this.can('delete_bill_payment').then(result => {
                        if(result.delete_bill_payment == true){
                            gThat.delete_bill_payment_permission = true;
                        }
                    });
                this.bill_payments = result.bill_payments;
                this.process_bill = result.process_bill;
                this.add_bill = result.add_bill;
            }).then(result => {
                if(this.bill_payments == true){
                    this.getPaymentEngineData();
                    this.billPaymentNewList();
                    this.billPaymentInprocessList();
                    this.billPaymentRejectedList();
                    this.billPaymentPaidList();
                    this.getMeezanStatus();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

            window.softDelete = function(billId,type){
                gThat.softDelete(billId,type);
            }
        },
        methods:{
            softDelete(billId,type) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {

                        axios.post("/api/billSoftDelete", {BillId: billId})
                            .then(res => {
                                if(res.status == 200){
                                    if(type == 'MAKER'){
                                        gThat.dtNewBPayments.ajax.reload(function(json){
                                            gThat.new_bills_count 	= json.recordsTotal;
                                            gThat.isDataTableLoading 	= false;
                                    }, false);}
                                    else if(type == 'REJECT'){
                                        gThat.dtRejectedBPayments.ajax.reload(function(json){
                                            gThat.rejected_bills_count 	= json.recordsTotal;
                                            gThat.isDataTableLoading 		= false;
                                        }, false);}
                                    this.$Progress.finish();
                                }else{
                                    this.$Progress.fail();
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Something went wrong!',
                                    })
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.$Progress.fail();
                                this.showAlertBox('error','couldnt find requested data');
                            });

                    }
                })
            },
            getMeezanStatus: function(){
                axios.get('/api/getMeezanStatus')
                .then(res => {
                    if(res.status == 200){
                        //for meezan case
                        this.meezan_balance = res.data.meezan_balance;
                        this.paymentEngine = res.data.payment_engine;
                        this.account_status = res.data.account_status;
                        if(this.account_status !== '' || this.account_status !== null){
                          if(this.account_status.code == 400){
                            this.account_msg = this.account_status.msg;
                          }
                        }
                        this.$Progress.finish();
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to get Meezan data');
                });
            },
            fetchNewBill : function(id){
                gThat.$Progress.start();
                gThat.form.id = id;
                gThat.form.post("/api/fetchNewBill")
                    .then(res => {
                        if(res.data.status == 200){
                            gThat.showToastBox('success','Bill successfully fetched! Please check New Tab');
                            $('#dt-new').DataTable().draw();
                            gThat.$Progress.finish();
                        }else{
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        gThat.$Progress.fail();
                        gThat.showAlertBox('error','Error to load form data');
                    });
            },
            downloadBillSlip : function(id){
                gThat.$Progress.start();
                axios.get('/api/downloadBillSlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Payment Slip.pdf'
                        link.click();
                        gThat.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'File Downloaded Successfully'
                        });
                    }else{
                        gThat.$Progress.finish();
                        swal.fire({
                            type: 'error',
                            title: 'Something Went Wrong Please Try Again'
                        });
                    }

                });
            },
            getPaymentEngineData: function(){
                this.$Progress.start();
                axios.post("/api/getPaymentEngine")
                    .then(res => {
                        if(res.status == 200){
                            this.paymentEngine = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            generateButton: function(e, amount){
                var checkFlag = false;
                var id = e.target.value;
                if(gThat.billIds.includes(id) == true){
                    gThat.billIds.splice( $.inArray(id,gThat.billIds), 1);
                    gThat.bill_selected_to_pay -= amount;
                }else{
                    gThat.billIds.push(id);
                    gThat.bill_selected_to_pay += amount;
                }
                $('input.processBill').each(function(){
                    if($(this).is(':checked')){
                        checkFlag = true;
                    }
                });
                if(gThat.$global.user_vr_corp == "YES" && gThat.bill_selected_to_pay > gThat.$global.user_vr_balance){
                    checkFlag = false;
                    gThat.display_process_bill = true;
                }else if(gThat.$global.user_vr_corp == "NO" && gThat.bill_selected_to_pay > gThat.corporateAccountBalance){
                    checkFlag = false;
                    gThat.display_process_bill = true;
                }else if ((gThat.billIds.length== 0) || (gThat.$global.user_vr_corp == "YES" && gThat.bill_selected_to_pay > gThat.$global.user_vr_balance) || (gThat.$global.user_vr_corp == "NO" && gThat.bill_selected_to_pay > gThat.corporateAccountBalance)){
                    gThat.display_process_bill = false;
                }
                if(checkFlag == true){
                    $('#processBill').removeAttr('disabled');
                }else{
                    $('#processBill').attr('disabled','true');
                }
            },
            billPaymentNewList: function(){
                var showBox = gThat.process_bill;
                gThat.dtNewBPayments = $('#dt-new').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getBillNewList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (data,json, type) {
                            gThat.bill_data = data.responseJSON.records;
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},/*process_bill*/
                        {"name":"title","mData": "title",
                            "mRender": function (data, type, full) {
                                var id = full['id'];
                                var title = full['title'];
                                var amountBill = full['amountBill'];
                                var to_return ='';
                                if(showBox == true){
                                    to_return += '<label class="check-holder">\n' +
                                        '<input name="bill_ids[]" class="processBill" value="'+id+'" type="checkbox" onclick="VueComponents.billPaymentsComponent.methods.generateButton(event,'+amountBill+')">\n' +
                                        '<span class="checkmark"></span>\n' +
                                        '</label>';
                                }
                                to_return += title;
                                return to_return;
                            }
                        },
                        {data: 'reason'},
                        {data: 'categoryName'},
                        {data: 'billerCodeName'},
                        {data: 'referenceNo'},
                        {data: 'amountBill'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = 'viewBillPayment/'+full['id'];
                                if(gThat.delete_bill_payment_permission == true && full['status'] == 'MAKER') {
                                    return '<div class="align-center"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+',\''+full['status']+'\')"  data-toggle="tooltip" data-placement="top" title="Delete" class="softDelete"> <i class="fas fa-trash-alt"></i> </a></div>';
                                } else {
                                    return '<div class="align-center"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a>';
                                }
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.new_bills_count = json.recordsTotal; }
                });
            },
            billPaymentInprocessList: function(){
                gThat.dtInProcessBPayments = $('#dt-inprocess').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getBillInProcessList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) {
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'title'},
                        {data: 'reason'},
                        {data: 'categoryName'},
                        {data: 'reason'},
                        {data: 'referenceNo'},
                        {data: 'amountBill'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = 'viewBillPayment/'+full['id'];
                                return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.inprocess_bills_count = json.recordsTotal; }
                });
            },
            billPaymentRejectedList: function(){
                gThat.dtRejectedBPayments = $('#dt-rejected').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getBillRejectedList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) {
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'title'},
                        {data: 'reason'},
                        {data: 'categoryName'},
                        {data: 'reason'},
                        {data: 'referenceNo'},
                        {data: 'amountBill'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = 'viewBillPayment/'+full['id'];
                                return '<div class="align-center"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="far fa-eye"></i> </a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+',\''+full['status']+'\')"  data-toggle="tooltip" data-placement="top" title="Delete" class="softDelete"> <i class="fas fa-trash-alt"></i> </a></div>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.rejected_bills_count = json.recordsTotal; }
                });
            },
            billPaymentPaidList: function(){
                gThat.dtPaidBPayments = $('#dt-paid').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/getBillPaidList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) {
                            if (type == "parsererror") {
                                gThat.$Progress.fail();
                            }else{
                                gThat.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'title'},
                        {data: 'reason'},
                        {data: 'categoryName'},
                        {data: 'reason'},
                        {data: 'referenceNo'},
                        {data: 'amountBill'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = 'viewBillPayment/'+full['id'];
                                return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="window.vueRouterPush(\''+$url+'\')" title="View" class="action view"> <i class="fas fa-eye"></i> </a>'+ 
                                '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" onclick="VueComponents.billPaymentsComponent.methods.downloadBillSlip(\''+full['id']+'\')" title="Download" class="action view"> <i class="fas fa-download"></i> </a>' +
                                '<a href="javascript:void(0)" data-toggle="tooltip" data-placement="top" onclick="VueComponents.billPaymentsComponent.methods.fetchNewBill(\''+full['id']+'\')" title="Fetch Again" class="action view"> <i class="fas fa-sync-alt"></i></a>';
                            }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => { this.paid_bills_count = json.recordsTotal; }
                });
            },
            reloadList(tabClicked){

				switch(tabClicked)
				{
					case 'new':
						if(gThat.currentActiveTab !== 'new')
						{
							gThat.isDataTableLoading = true;

							gThat.dtNewBPayments.ajax.reload(function(json){
								gThat.new_bills_count 	= json.recordsTotal;
								gThat.isDataTableLoading 	= false;
							}, false);

							gThat.currentActiveTab = 'new';	
						}
					break;

					case 'inprocess':
						if(gThat.currentActiveTab !== 'inprocess')
						{
							gThat.isDataTableLoading = true;

							gThat.dtInProcessBPayments.ajax.reload(function(json){
								gThat.inprocess_bills_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'inprocess';
						}
					break;

					case 'rejected':
						if(gThat.currentActiveTab !== 'rejected')
						{
							gThat.isDataTableLoading = true;

							gThat.dtRejectedBPayments.ajax.reload(function(json){
								gThat.rejected_bills_count 	= json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'rejected';
						}
					break;

					case 'paid':
						if(gThat.currentActiveTab !== 'paid')
						{
							gThat.isDataTableLoading = true;

							gThat.dtPaidBPayments.ajax.reload(function(json){
								gThat.paid_bills_count = json.recordsTotal;
								gThat.isDataTableLoading 		= false;
							}, false);

							gThat.currentActiveTab = 'paid';
						}
					break;
				}
            },
            getCorporateCompanyBalance(){
                axios.get("/api/getCurrentBalanceData")
                .then(res => {
                    if(res.status == 200){
                        this.corporateAccountBalance = parseInt(res.data.data.balance);
                    }else{
                    this.showAlertBox('error','Error to fetch balance --- !');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to fetch balance - !');
                });
            }
        }
    }
</script>